import Constant from '@/const'
import Store from '@/store/index.js'
export default {
  namespaced: true,
  state: {
    data: [],
  },
  mutations: {
    create(state, data) {
      state.data = data
    },
    update(state, data) {
      state.data = state.data.map((d) => {
        if (d.id === data.id) return data
        else return d
      })
    },
    delete(state, data) {
      state.data = state.data.filter((d) => d.id !== data.id)
    },
  },
  actions: {
    // 請求先取得
    get({ commit, dispatch }) {
      const request = {
        headers: {
          Authorization: `Bearer ${Store.state.auth.ACCESS_TOKEN}`,
          Accept: 'application/json',
        },
        url: `${Constant.API_URL.INVOICE}`,
        error: { message: '請求先取得に失敗しました。' },
      }
      return dispatch('http/get', { ...request }, { root: true })
        .then((res) => {
          commit('create', res.data)
        })
        .catch((err) => {
          throw new Error(err.message)
        })
    },

    // 請求先編集
    update({ commit, dispatch }, data) {
      const request = {
        headers: {
          Authorization: `Bearer ${Store.state.auth.ACCESS_TOKEN}`,
          Accept: 'application/json',
        },
        url: `${Constant.API_URL.INVOICE}/${data.id}`,
        params: data,
        error: { message: '請求先登録に失敗しました。' },
      }
      return dispatch('http/put', { ...request }, { root: true })
        .then((res) => {
          commit('update', data)
        })
        .catch((err) => {
          throw new Error(err.message)
        })
    },

    // 請求先登録
    delete({ commit, dispatch }, data) {
      const request = {
        headers: {
          Authorization: `Bearer ${Store.state.auth.ACCESS_TOKEN}`,
          Accept: 'application/json',
        },
        url: `${Constant.API_URL.INVOICE}/${data.id}`,
        error: { message: '請求先削除に失敗しました。' },
      }
      return dispatch('http/delete', { ...request }, { root: true })
        .then((res) => {
          commit('delete', data)
        })
        .catch((err) => {
          throw new Error(err.message)
        })
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/invoice.js